import backend from './backendService';

class InventoryService {
  async getSources(){
    return backend.get(`/inventory/sources`);
  }
}

export default new InventoryService();
